import * as types from '../../Types';

export default () => {
  return dispatch => {
    const action = {
      type: types.BROADCAST_CLEAR_STAGED_SOURCES
    };

    dispatch(action);
  };
};
